import React from 'react';
import { Popover } from '@douyinfe/semi-ui';

interface Props {
  key: string;
  description: string;
  children: React.ReactElement;
}
export const PopContainer = (props: Props) => {
  const { key, description, children } = props;
  const popContent = (content: string) => <div>{content}</div>;
  return (
    <Popover
      key={key}
      position="topLeft"
      showArrow={description.length > 0}
      style={{
        backgroundColor: '#41464C',
        borderColor: '#41464C',
        borderRadius: '6px',
        color: 'white',
      }}
      content={popContent(description ?? '')}>
      {children}
    </Popover>
  );
};
